'use strict';

export default class presencial {
  constructor(){
    this.proxlotePop_template = '<div class="popover popshare" role="tooltip">'+
    '<div class="arrow"></div>'+
    '<h3 class="popover-header"></h3>'+
    '<div class="popover-close"><i class="fas fa-times"></i></div>'+
    '<div class="popover-body"></div>'+
    '</div>';
    this.modal_template = '<div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">'+
    '<div class="modal-dialog"><div class="modal-content"><div class="modal-header">'+
    '<h5 class="modal-title" id="staticBackdropLabel">Modal title</h5>'+
    '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>'+
    '</div><div class="modal-body">...</div></div></div></div>';
    this.whatsappNum = "";
    this.whatsappMsg = "";
    this.numleilao="";
    this.urlimg = "https://d1o6h00a1h5k7q.cloudfront.net/imagens/";
    this.imgbranco='imagens/branco.png';
    this.idleilao = "";
    this.loteatual="";
    this.pecaatual="";
    this.statusatual="";
    this.valorpecaatual="";
    this.logado=0;
    this.req=0;
    this.espera=10000;
    this.coleta=3;
    this.auxcoleta=3;
    this.site="";
    this.idsite="";
    this.sessaocli="";
    this.urlsite = "";
    this.cotacaous = "";
    this.cotacaoeu = "";
    this.mostracotacao = false;
    this.stringvideo = "";
    this.semlance = 0;
    this.lancevencedor = {
      IDLANCE:"",
      TIPOLANCE:"",
      VALOR:"",
      IDCLIENTE:"",
      VENCEDOR:true,
    };
    this.registralances = [];
    this.mensagens = {
      ja_possui: "Você já possui o lance vencedor nessa peça.",
      cadastro_pendente: "Seu cadastro esta pendente, favor entrar em contato com a Galeria.",
      leilao_pregao: "<p><b>Leilão não está em Pregão</b></p>",
      leilao_invalido: "<p><b>Número de Leilão Inválido!</b></p>",
      mensagem_salao: "",
    }
  }
  ismobile(){
    var chkmobile = $('.chk-mobile').is(":visible");
    return chkmobile;
  }
  scrollToBottom(pelement) {
    var outsider = document.getElementById(pelement);
    outsider.scrollBy({
      top: outsider.offsetHeight,
      behavior: 'smooth'
    });
  }
  scrollToTop(pelement) {
    var outsider = document.getElementById(pelement);
    outsider.scrollBy({
      top: -outsider.offsetHeight,
      behavior: 'smooth'
    });
  }
  scrollLft(pelement) {
    var outsider = document.getElementById(pelement);
    outsider.scrollBy({
      left: -122,
      behavior: 'smooth'
    });
  }
  scrollUp(pelement) {
    var outsider = document.getElementById(pelement);
    outsider.scrollBy({
      top: -89,
      behavior: 'smooth'
    });
  }
  scrollBottom(pelement) {
    var outsider = document.getElementById(pelement);
    outsider.scrollBy({
      top: 89,
      behavior: 'smooth'
    });
  }
  scrollRight(pelement) {
    var outsider = document.getElementById(pelement);
    outsider.scrollBy({
      left: 122,
      behavior: 'smooth'
    });
  }
  openCloseLances(ptype){
    var lancelist =  $('.is-lances-list');
    var smalllancelist =  $('.is-lote-smalllancelist');
    var chklanceslist = lancelist.hasClass('is-open');
    function removeOpen(){
      lancelist.removeClass('is-open');
      smalllancelist.removeClass('is-open');
    }
    function addOpen(){
      lancelist.addClass('is-open');
      smalllancelist.addClass('is-open');
    }
    lancelist.removeAttr('style');
    chklanceslist === true ? removeOpen() : addOpen();
    if(ptype==="close") {
      removeOpen();
    }
  }

  criaModal(ptitle, pcontent){
    var gar = $('.modal');
    if(gar.length===0){
      $('body').append(this.modal_template);
    }
    $('.modal-title').html(ptitle);
    $('.modal-body').html(pcontent);
    if(gar.length===0){
      $('.modal').modal('show');
    }
  }

  /**
  * atualiza as informacoes principais
  * @param {object} pobject objeto de informacoes
  */
  atualizaInfo(pobject){
    this.whatsappNum = pobject.whatsapp_num;
    this.whatsappMsg = pobject.whatsapp_msg;
    this.numleilao = pobject.numleilao;
    this.idleilao = pobject.idleilao;
    this.sessaocli = pobject.sessaocli;
    this.urlsite = pobject.urlsite;
    this.site = pobject.site;
    this.idsite = pobject.idsite;
    this.cotacaous = pobject.cotacao_us;
    this.cotacaoeu = pobject.cotacao_eu;
    this.mostracotacao = pobject.mostracotacao;
    this.stringvideo = pobject.stringvideo;
    this.logado=pobject.logado;
  }

  /**
  * define o caminho para o le_registro_pregao
  * @param {string} psite nome do site
  */
  defineLeRegistro(psite){
    var registro;
    switch(psite){
      case "levy":
        registro = "https://d2khfqh5bqnqgx.cloudfront.net/1s/le_registro_pregao_cflv.asp"; 
        break;
      case "antonio":
        registro = "https://d2khfqh5bqnqgx.cloudfront.net/1s/le_registro_pregao_cfan.asp";
        break; 
      case "blombo":
        registro = "https://d2khfqh5bqnqgx.cloudfront.net/1s/le_registro_pregao_cfbl.asp";
        break;    
      case "centurys":
        registro = "https://d2khfqh5bqnqgx.cloudfront.net/1s/le_registro_pregao_cfce.asp";
        break;
      case "ernani":
        registro = "https://d2khfqh5bqnqgx.cloudfront.net/1s/le_registro_pregao_cfer.asp";
        break;  
      case "dagsaboya":
        registro = "https://d2khfqh5bqnqgx.cloudfront.net/1s/le_registro_pregao_cfda.asp";
        break;
      default:
        registro = "https://d2khfqh5bqnqgx.cloudfront.net/1s/le_registro_pregao_cfbr_v1.asp";
    }
    return registro;
  }

  /**
  *	verifica se a imagem extra existe
  * @param {string} plink link da imagem
  * @param {string} pfolder div para adicionar extras
  * @param {string} ptemplate template para adicionar
  */
  createImg = function(plink, pfolder, ptemplate) {
    var img = new Image();
    img.src = plink;
    img.onload = function() {
      pfolder.append(ptemplate);
    }
    img = null;
  }

   /**
  * acerta a pontuação do número
  * @param {number} v nome do site
  */
  acertaNumero(v){
    var firstcheck, secondcheck;
    firstcheck = toString(v);
    firstcheck.indexOf('.')? secondcheck=Number(v).toFixed(2) : secondcheck = v;
    var novoV = Number(secondcheck).toLocaleString('pt-BR');
    if (novoV.indexOf(',')>-1){
      return novoV
    } else {
      return novoV+",00"
    }
  }

  /**
  * Avisa ao usuário que existe mensagem ativa no salão
  * @param {boolean} pboolean true se tem mensagem
  */ 
  avisaMsg(pboolean){
    var alertaicon = $('.alerta-icon');
    pboolean ? alertaicon.addClass('is-on') : alertaicon.removeClass('is-on');
  }

  /**
  * Atualiza a animacao do elemento
  * @param {object} pelement classe do elemento
  * @param {string} pclass classe da animacao
  * @param {boolean} premove remove ou adiciona
  */ 
  atualizaAnimacao(pelement, pclass, premove){ 
    premove ?          
      pelement.removeClass("animate__animated animate__"+pclass)
    :
      pelement.addClass("animate__animated animate__"+pclass) 
    ;   
  }

  controlaLanceBtn = function(pstatus){
    var spanlist = [ "loading", "success", "error" ]
    if(pstatus === "clear"){
      spanlist.forEach(function(item, index){
        $('#Botao').removeClass(item);
      });
    } else {
      spanlist.forEach(function(item, index){
        pstatus === item ? $('#Botao').addClass(pstatus) : $('#Botao').removeClass(item);
      });
    }
  }


/**
* Função para fazer lance
* @param {object} pelement ativa ou desativa
*/  
Fazerlance(pelement){
  var obj = this;
  obj.controlaLanceBtn("loading");
  var vencedoratual = "0";
  vencedoratual = obj.lancevencedor.IDCLIENTE;
    if (vencedoratual == obj.sessaocli) {
      alert('Você já possui o lance vencedor nessa peça');
      obj.controlaLanceBtn("clear");
      return false;
    } else {
        if (obj.statusatual!='F'){
          var request = $.ajax({
            url: "lote_fazerlance.asp",
            type: "POST",
            data: {idpeca : obj.pecaatual, valor : obj.valorpecaatual, leilao : obj.idleilao},
            dataType: "html"
          });
          request.done(function(msg) {
            var parsedmsg = $($.parseHTML(msg)).filter('.resposta').html();
            if (parsedmsg=='*inativo*') {
              obj.controlaLanceBtn("error");
              alert('Seu cadastro esta pendente, favor entrar em contato com a Galeria.');
              setTimeout(function(){
                obj.controlaLanceBtn("clear");
              }, 1000);
              window.location.href='../default.asp'; 
            } else if(parsedmsg=="N"){
              obj.controlaLanceBtn("error");
              setTimeout(function(){
                obj.controlaLanceBtn("clear");
              }, 1000);
            } else {
              obj.controlaLanceBtn("success");
              setTimeout(function(){
                obj.controlaLanceBtn("clear");
              }, 1000)
            }
          });
        }
    }
  }

  /**
  * Mantem a variavel de sessao do cliente logado
  */   
  Alive(){
    var obj = this;
    var request = $.ajax({
      url: "keepalive.asp",
      dataType: "html"
    });
    request.done(function(msg) {
      obj.logado=(msg>0)?1:0;
      if(obj.logado==1){
        // cartelacli=msg;
        obj.sessaocli=msg;
      } else {
        // cartelacli=''; 
        obj.sessaocli=''; 
        obj.logado=0;
      }  
    });
  }

  /**
  * Ativa ou desativa os valores do presencial
  * @param {boolean} pchoice ativa ou desativa
  */   
  ativaDesativaValores(pchoice){
    var commander = $('.is-pricebid-wrap');
    if(pchoice){
      commander.removeClass('no-show');
      if(this.mostracotacao === false) {
        commander.addClass('no-show-cotacao');
      } else {
        commander.removeClass('no-show-cotacao');
      }
    } else {
      commander.addClass('no-show');
      $('.is-lances-wrap ul').html("");
      $('.is-qtd-lances').html("0");
    }
  }

  imprimeToast(pcomprador, pcount){
    var toast = false;
    var toastcolor, toastmsg;
    switch(this.statusatual){
      case("F"):
        if(this.sessaocli!=""){
          $('.is-lance-btn').attr('disabled', 'disabled');
        }
        toast = true;
        if(pcomprador=="\r" || pcomprador==''){
          toastcolor="has-orange-alert";
          toastmsg="PASSA O LOTE";
        } else {
          toastcolor="has-black-alert";
          toastmsg = "LOTE VENDIDO"
        }
        break;
      case("P"):
        $('.is-lance-btn').removeAttr('disabled');
        toastcolor="has-blue-alert";
        toastmsg = "Lote em Pregão...";
        break; 
      case("X"):
        $('.is-lance-btn').removeAttr('disabled');
        toastcolor="has-red-alert";
        toastmsg = "Lote prestes a fechar, lance rápido";
        break; 
      case("S"):
        if(this.sessaocli!=""){
          $('.is-lance-btn').attr('disabled', 'disabled');
        }
        toastcolor="has-orange-alert";
        toastmsg="PASSA O LOTE";
        break;
      case("E"):
        $('.is-lance-btn').removeAttr('disabled');
        toastcolor="has-blue-alert";
        toastmsg="Aguarde... peça sendo examinada na Sala";
        break;
      case("R"):
        location.reload();
        break;  
      case("1"):
        $('.is-lance-btn').removeAttr('disabled');
        toastcolor="has-orange-alert";
        toastmsg="DOU-LHE UMA...";
        break;  
      case("2"):
        $('.is-lance-btn').removeAttr('disabled');
        toastcolor="has-orange-alert";
        toastmsg="DOU-LHE DUAS...";
        break; 
      case("3"):
        $('.is-lance-btn').removeAttr('disabled');
        toastcolor="has-orange-alert";
        toastmsg="VOU BATER...";
        break;  
      case("4"):
        if(this.sessaocli!=""){
          $('.is-lance-btn').attr('disabled', 'disabled');
        }
        toastcolor="has-orange-alert";
        toastmsg="FECHANDO...";
        break;     
      case("T"):
        $('.is-lance-btn').removeAttr('disabled');
        toastcolor="has-blue-alert";
        toastmsg="Aguarde... Lote com chamadas telefônicas.";
        break; 
      default:
        $('.is-lance-btn').removeAttr('disabled');
        $('.toast').toast('hide');
        break;                     
    }
    var toastTemplate = '<div class="toast hide '+toastcolor+' is-roboto-condensed" role="alert" aria-live="assertive" aria-atomic="true" data-delay="2000">'+
    '<div class="toast-header"><i class="fas fa-exclamation-circle mr-2"></i><strong class="mr-auto">Alerta Leiloeiro</strong>'+
    '<button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">'+
    '<span aria-hidden="true">&times;</span></button></div>'+
    '<div class="toast-body">'+toastmsg+'</div></div>';

    var alertaTemplate = '<li class="animate__animated animate__fadeInLeft leilao-normal d-flex font-extra-small px-3 py-2 is-lance-alerta '+toastcolor+'">'+
    '<p class="mb-0">*** Alerta: '+toastmsg+' ***</p></li>';

    var fixedAlerta = '<div class="animate__animated animate__fadeIn leilao-normal d-flex font-small px-3 py-2 is-lance-alerta '+toastcolor+'">'+
    '<p class="mb-0">Alerta:<br> '+toastmsg+' </p></div>';

    setTimeout(function(){
      $('.is-lances-wrap ul').prepend(alertaTemplate);
      $('.is-fixed-alert').html(fixedAlerta);
    },(pcount+1)*100);

  }

  defineHiddenCliente(pidcliente){
    var hiddencliente;
    var strcliente = ""+pidcliente+"";
    if(this.sessaocli != pidcliente){
      var plength = (pidcliente+'').length;
      if(plength <4){
        hiddencliente=strcliente.substring(0,1) +'*****';
      } else if (plength <6) {
        hiddencliente=strcliente.substring(0,2) +'****';
      } else {
        hiddencliente=strcliente.substring(0,3) +'***';
      }
    } else {
      hiddencliente=pidcliente;
    }
    return hiddencliente;
  }


  // gera a renderização do lance na listagem
  geraLanceRender(pobject, picon, planceclass, pcount, pnovolote){
    var printelement;

    if(pobject.VENCEDOR===false){  
      var animation;
      pnovolote ? animation = "fadeInDownBig" : animation = "fadeInLeft";

      printelement = '<li id="'+pobject.IDLANCE+'" class="animate__animated animate__'+animation+' leilao-normal d-flex font-small px-3 py-2 '+planceclass+'">'+
      '<div class="d-flex flex-column justify-content-center is-lance-iconspace">'+
      '<p class="mb-0 text-left">'+picon+'</p>'+
      '</div><p class="mb-0">'+
      '<span class="valor">R$ '+this.acertaNumero(pobject.VALOR)+'</span> - '+
      '<span class="local">'+pobject.TIPOLANCE+'</span> - '+
      '<span>'+pobject.IDCLIENTE+'</span></p></li>';
    } else {
      pnovolote ? animation = "fadeInDownBig" : animation = "fadeIn";

      printelement = '<li class="leilao-vencedor animate__animated animate__'+animation+'  d-flex align-items-stretch '+planceclass+'"><div class="my-2 px-3 d-flex flex-column justify-content-center is-lance-iconspace">'+
      '<p class="mb-0 text-left"><i class="fas fa-award"></i></p>'+
      '</div><div class="my-2 px-3"><p class="nome-3 font-extra-small mb-1 has-uppercase is-roboto-condensed"> Lance vencedor atual</p><p class="mb-0 font-small font-bold">'+
      '<span class="valor">R$ '+this.acertaNumero(pobject.VALOR)+'</span> - '+
      '<span class="local">'+pobject.TIPOLANCE+'</span> - '+
      '<span>'+this.defineHiddenCliente(pobject.IDCLIENTE)+'</span></p></div></div>';
    }  

    if(pobject.VENCEDOR===false){ 
      if(pcount) {
        setTimeout(function(){
          $('.is-lances-wrap ul').prepend(printelement);
        },pcount*100);
      } else {
        $('.is-lances-wrap ul').prepend(printelement);
      }
    } else {
      $(".leilao-vencedor").remove();
      $('.is-lances-wrap ul').append(printelement);
    }  

  }

  formatNumber(n, p, ts, dp) {
    var t = [];
    // Get arguments, set defaults
    if (typeof p  == 'undefined') p  = 2;
    if (typeof ts == 'undefined') ts = ',';
    if (typeof dp == 'undefined') dp = '.';
  
    // Get number and decimal part of n
    n = Number(n).toFixed(p).split('.');
  
    // Add thousands separator and decimal point (if requied):
    for (var iLen = n[0].length, i = iLen? iLen % 3 || 3 : 0, j = 0; i <= iLen; i+=3) {
      t.push(n[0].substring(j, i));
      j = i;
    }
    // Insert separators and return result
    return t.join(ts) + (n[1]? dp + n[1] : '');
  }

  /**
  * Atualiza os campos necessários com o ultimo lance
  * @param {number} pnum Valor do ultimo lance
  * @param {number} pqtd Quantidade de lances
  */ 
  atualizaValores(picon, ptipo, pqtd){    
    //this.valorpecaatual = this.lancevencedor.VALOR;
    //var valorincremento = incremento(this.idleilao, this.valorpecaatual, pqtd);   
    this.valorpecaatual = incremento(this.idleilao, this.lancevencedor.VALOR, pqtd);   
    var winning = '';
    // atualiza o campo valor atual
    $('.va-label').html('Lance vencedor atual');
    $('.is-valor-peca').html(this.acertaNumero(this.lancevencedor.VALOR));
    if(this.lancevencedor.IDCLIENTE===parseInt(this.sessaocli)){
      $('.is-valor-atual-wrap').addClass('is-lance-user');
      winning = ' - Vencendo';
    } else {
      $('.is-valor-atual-wrap').removeClass('is-lance-user');
    }
    this.atualizaAnimacao($('.is-valor-atual-wrap'), "fadeIn", false);

    if(this.sessaocli!=""){
      //$('.lance-area').find('.is-btn-type-text').html('Lance  R$ '+this.acertaNumero(this.valorpecaatual));
      $('.lance-area').find('.is-btn-type-text-logado').html('Lance  R$ '+this.acertaNumero(this.valorpecaatual));
    }

    // atualiza o small display
    var smalldisplay_template = '<div class="is-lance-small '+ptipo+'"><div class="d-flex flex-column justify-content-center is-lance-iconspace mr-1">'+picon+'</div>'+
    '<p class="mb-0 text-left local">'+this.lancevencedor.TIPOLANCE + winning+'</p></div>';
    $('.is-qtd-lances').html(pqtd);
    //$('.is-lance-small-display').html(smalldisplay_template);
    $('.is-lance-tipo-2').html(smalldisplay_template);

    //atualiza o valor atual dentro da caixa de lances
    this.geraLanceRender(this.lancevencedor, picon, ptipo);

    if(this.mostracotacao===true){
      // var valorus = (this.lancevencedor.VALOR / this.cotacaous).toFixed(2).replace('.', ',');
      // var valoreu = (this.lancevencedor.VALOR / this.cotacaoeu).toFixed(2).replace('.', ',');
      var valorus = this.formatNumber((this.lancevencedor.VALOR / this.cotacaous), 2, '.', ',');
      var valoreu = this.formatNumber((this.lancevencedor.VALOR / this.cotacaoeu), 2, '.', ',');
      $('.is-dolar-cotacao').html(valorus);
      $('.is-euro-cotacao').html(valoreu);
     };
  }

    /**
  * Atualiza os campos necessários com o ultimo lance
  * @param {number} pnum Valor do ultimo lance
  * @param {number} pqtd Quantidade de lances
  */ 
 atualizaSemLance(pvalor){    
  //this.valorpecaatual = this.lancevencedor.VALOR;
  //var valorincremento = incremento(this.idleilao, this.valorpecaatual, pqtd);   
  this.valorpecaatual = pvalor;   
  this.semlance = 1;

  var semlances = '<div class="is-lance-small is-lance-semlance"><div class="d-flex flex-column justify-content-center is-lance-iconspace mr-1"><i class="fas fa-info-circle"></i></div><p class="mb-0 text-left local">Lote sem lance</p></div>';

  // atualiza o campo valor atual
  $('.va-label').html('Valor inicial');
  $('.is-lance-tipo-2').html(semlances);
  $('.is-valor-atual-wrap').removeClass('is-lance-user');
  $('.is-valor-peca').html(this.acertaNumero(pvalor));
  this.atualizaAnimacao($('.is-valor-atual-wrap'), "fadeIn", false);

  if(this.sessaocli!=""){
    //$('.lance-area').find('.is-btn-type-text').html('Lance  R$ '+this.acertaNumero(this.valorpecaatual));
    $('.lance-area').find('.is-btn-type-text-logado').html('Lance  R$ '+this.acertaNumero(pvalor));
  }

  // atualiza o small display
  $('.is-qtd-lances').html(0);

  if($('.sem-lance').length === 0){
    var printelement = '<li class="leilao-vencedor animate__animated animate__fadeIn d-flex align-items-stretch sem-lance"><div class="my-2 px-3 d-flex flex-column justify-content-center is-lance-iconspace">'+
    '<p class="mb-0 text-left"><i class="fas fa-info-circle"></i></p>'+
    '</div><div class="my-2 px-3 d-flex flex-column justify-content-center"><p class="nome-3 font-extra-small mb-1 has-uppercase is-roboto-condensed"> Lote sem lance</p><p class="mb-0 font-small font-bold">'+
    '</p></div></div>';
    $('.is-lances-wrap ul').append(printelement);    
  }

  if(this.mostracotacao===true){
  //  var valorus = (pvalor / this.cotacaous).toFixed(2).replace('.', ',');
  //  var valoreu = (pvalor / this.cotacaoeu).toFixed(2).replace('.', ',');
   var valorus = this.formatNumber((pvalor / this.cotacaous), 2, '.', ',');
   var valoreu = this.formatNumber((pvalor / this.cotacaoeu), 2, '.', ',');
   $('.is-dolar-cotacao').html(valorus);
   $('.is-euro-cotacao').html(valoreu);
  };
}

  /**
  * Le o registro pregao
  * @param {boolean} pfirst verifica se é o primeiro load
  */  
  LePregao(pfirst){
    var obj = this;
    //obj.auxcoleta=obj.auxcoleta+1;
    //if(obj.auxcoleta>=obj.coleta){obj.auxcoleta=0};
    var url_leregistro = obj.defineLeRegistro(obj.site);
    var request = $.ajax({
      url: url_leregistro,
      type: "GET",
      data: {i: obj.idleilao, j:obj.idsite, p:obj.pecaatual},
      crossDomain: true,
      dataType: "html"
    });
    request.done(function(msg){
      //const t0 = performance.now();
      var array1="";
      var b=0;
      // leilao não está em pregão
      if(msg=="np"){
        obj.criaModal('Alerta', obj.mensagens.leilao_pregao);
      // leilão invalido  
      } else if(msg=="invalido"){
        obj.espera=900000;
        obj.criaModal('Alerta', obj.mensagens.invalido);
      // leilao esta em pregao e valido  
      } else {
        // se for o primeiro load, muda o status do loaded para true
        array1=msg.split("*|*");
        var objinfoleilao = JSON.parse(array1[1]);

        var novolote;
        objinfoleilao.INFOLEILAO.NOVO_LOTE ? novolote = true : novolote = false;

        var mensagem_salao = objinfoleilao.INFOLEILAO.AVISO;
        // tem mensagem salao
        if(mensagem_salao.length>2){
          obj.mensagens.mensagem_salao = mensagem_salao
          obj.criaModal('Mensagem salão',  obj.mensagens.mensagem_salao);
          obj.avisaMsg(true);

          // quando entra mensagem salao, desabilita o botao de lance se
          if($('.is-lance-btn').hasClass('is-btn-type-on')){
            $('.is-lance-btn').attr('disabled', 'disabled');
          }

          // se tiver sido removida mensagem, 
        } else {
          // quando sai a mensagem salao, se o status for diferente dos abaixo, habilita botao de lance
          var statusarray = ["4", "S", "F"];
          if(!statusarray.includes(objinfoleilao.INFOLEILAO.STATUS)){
            $('.is-lance-btn').removeAttr('disabled');
          }
          obj.mensagens.mensagem_salao = "";
          $('.modal').modal('hide');
          $('.modal').on('hidden.bs.modal', function (event) {
            $('.modal').modal('dispose');
            $('.modal').remove();
          })
          obj.avisaMsg(false);
        }

        //se for nova peça, atualiza informacoes
        if (novolote === true){

          obj.openCloseLances("close");

          obj.semlance = 0;
          obj.registralances = []; // limpa registro de lances
          $('.is-lances-wrap ul').html(""); //limpa lista de lances
          $('.is-fixed-alert').html(""); //limpa lista de lances
          obj.pecaatual=objinfoleilao.INFOLEILAO.ID_PECA; //atualiza id da peca

          //console.log('qtdlotes'+parseInt(objinfoleilao.INFOLEILAO.QTD_LOTES)+"/qtdatual:"+parseInt(objinfoleilao.INFOLEILAO.QTD_ATUAL));
          var percentage = Math.floor(100 * parseInt(objinfoleilao.INFOLEILAO.QTD_ATUAL) / parseInt(objinfoleilao.INFOLEILAO.QTD_LOTES));
          if (percentage>100){percentage=100;}
          $(".progress-info").html("Peça nº <b>"+objinfoleilao.INFOLEILAO.QTD_ATUAL+"</b> de <b>"+objinfoleilao.INFOLEILAO.QTD_LOTES+"</b> - <b>"+percentage+"%</b>");
          $(".progress-bar").css("width", percentage+"%");

          // troca imagem principal e zoom
          $('.main-img').attr('src', obj.urlimg+'img_m/'+obj.idleilao+'/'+objinfoleilao.INFOLEILAO.ID_PECA+'.jpg');
          $('.main-img').attr('data-zoom',  obj.urlimg+'img_g/'+obj.idleilao+'/'+objinfoleilao.INFOLEILAO.ID_PECA+'.jpg');

          // limpa imagens extra e adiciona as novas
          $('.is-imagemextra-list').html("");
          for(var i=0; i<6;i++) {
            
            var urltestimg,urltestimg_g, ac ;
            if(i===0) {
              ac = "active"
              urltestimg = obj.urlimg+'img_m/'+obj.idleilao+'/'+objinfoleilao.INFOLEILAO.ID_PECA+'.jpg'
              urltestimg_g = obj.urlimg+'img_g/'+obj.idleilao+'/'+objinfoleilao.INFOLEILAO.ID_PECA+'.jpg'
            } else {
              ac = ""
              urltestimg = obj.urlimg+'img_m/'+obj.idleilao+'/'+objinfoleilao.INFOLEILAO.ID_PECA+'_'+i+'.jpg'
              urltestimg_g = obj.urlimg+'img_g/'+obj.idleilao+'/'+objinfoleilao.INFOLEILAO.ID_PECA+'_'+i+'.jpg'
            }
            var li_template = '<li class="px-2 pb-3"><a href="#" class="is-lotethumb-wrap d-flex flex-column justify-content-center '+ac+'"><div class="d-block text-center mh-100"><img class="lotethumb lotethumb-'+i+' img-fluid mh-100" src="'+urltestimg+'" title="" data-original="'+urltestimg_g+'" alt="Imagem do lote"></div></a></li>';
            var slidertemplate = '<div id="car-'+i+'" class="carousel-item"><div class=car-wrap ><img src="'+urltestimg+'" class="img-fluid"></div></div>';
            obj.createImg(urltestimg, $('.is-imagemextra-list'), li_template);
            if(i>0){
              $('#car-'+i).remove();
              obj.createImg(urltestimg, $('.carousel-inner'), slidertemplate)
            } else {
              $('#car-main').addClass('active');
            }
          }

          if(obj.ismobile()){
            $('.carousel').carousel({
              touch: true,
              ride: false,
            });
          }

          //atualiza lote atual
          var loteatual = objinfoleilao.INFOLEILAO.LOTE + objinfoleilao.INFOLEILAO.EXTRA;
          $(".is-lotenumber").html(loteatual);
          obj.loteatual = loteatual;

          //atualiza valor inicial
          $('.is-valor-inicial').html(obj.acertaNumero(objinfoleilao.INFOLEILAO.VALOR_CONTRATADO));

          //atualiza Descricao
          $('.is-lote-fulldescription').html(objinfoleilao.INFOLEILAO.DESCRICAO);
          $('.is-desc-popover').attr('data-content', '<div class="pop-desc-wrap">'+objinfoleilao.INFOLEILAO.DESCRICAO+'</div>');
          $('.is-desc-popover').attr('title', 'Lote '+loteatual);
          var defdot, defdesc;
          if(objinfoleilao.INFOLEILAO.DESCRICAO.length > 180){
            defdesc = objinfoleilao.INFOLEILAO.DESCRICAO.substr(0,180);
            defdot = "..."
            $('.is-desc-scrl').addClass('d-md-block');
          } else {
            defdesc = objinfoleilao.INFOLEILAO.DESCRICAO;
            defdot = ""
            $('.is-desc-scrl').removeClass('d-md-block');
          }

          $('.is-lote-shortdescription').html(defdesc+defdot);

          //limpa status da peca e alertas
          obj.statusatual = "";
          $('.is-toast-holder').html("");

          //limpa maior lances
          obj.lancevencedor.IDLANCE = "";
          obj.lancevencedor.TIPOLANCE = "";
          obj.lancevencedor.VALOR = "";
          obj.lancevencedor.IDCLIENTE = "";

          //atualiza prox lotes
          var prox_lotes = JSON.parse(array1[3]);
          function buildproxlote(pcurrent, plote,pidpeca, pdescricao,pvalor){
            var ac;
            pcurrent ? ac = "active" : ac=""; 
            return '<li class="d-flex flex-column px-0 px-md-3 pt-3 pt-md-0 '+ac+'">'+
            '<p class="is-nextlote-text m-0 has-uppercase is-roboto-condensed font-extra-small px-2">Lote '+ plote+'</p>'+
            '<a tabindex="0" class="is-nextlote-wrap d-flex justify-content-center flex-column has-popover" role="button" data-toggle="popover"  data-trigger="focus" title="Lote '+ plote+'" data-content="<div class=\'d-flex flex-column justify-content-center is-popoverimg-wrap\'><div class=\'d-block text-center mh-100\'><a href=\'../peca.asp?ID='+pidpeca+'\' class=\'\'><img class=\'img-fluid mh-100\' src=\''+obj.urlimg+'img_m/'+obj.idleilao+'/'+pidpeca+'.jpg\' alt=\''+pdescricao+'\'></div></div><div class=\'is-popover-text my-2\'><p class=\'m-0\'>'+pdescricao+'</p></div><div class=\'is-popover-text my-2\'><p class=\'valor-label has-gray-color m-0\'>Valor atual:</p><p class=\'valor-value mt-2 mb-0 has-black-color font-bold is-roboto font-medium\'><span class=\'has-gray-color font-small\'>R$</span> '+obj.acertaNumero(pvalor)+'</p></p></div></a>">'+
            '<div class="d-block text-center mh-100">'+
            '<img class="nextlote img-fluid mh-100" src="'+obj.urlimg+'img_m/'+obj.idleilao+'/'+pidpeca+'.jpg" title="'+pdescricao+'" alt="'+pdescricao+'">'+
            '</div></a></li>';
          }
          var proxwrap = $('#nextlote-list-wrap ul');
          // limpa a lista de lotes
          proxwrap.html("");
          // adiciona o lote atual na lista
          //proxwrap.append(buildproxlote(true, loteatual, objinfoleilao.INFOLEILAO.ID_PECA, objinfoleilao.INFOLEILAO.DESCRICAO));
          // adiciona os proximos lotes
          prox_lotes.PROXIMOS_LOTES.forEach(function(element,index){
            proxwrap.append(buildproxlote(false, element.LOTE +  element.EXTRA, element.ID, element.DESCRICAO, element.VALOR));
          });

        }

        var mensagem_lance = JSON.parse(array1[0]);
        // pega o maior lance retornado
        var maiorlance = mensagem_lance.LANCES[0];

        // se tiver lances
        if(mensagem_lance.LANCES.length>0) {
          if(obj.lancevencedor.IDLANCE != maiorlance.IDLANCE) {
          var icon, lanceclass;
          //funcao para definir o icone e o tipo de lance
          function defineIconLance(pelement){
            if(parseInt(pelement.IDCLIENTE) === parseInt(obj.sessaocli)){
              icon = '<i class="fas fa-user"></i>'
              lanceclass = 'is-lance-user';
            } else {
              switch(pelement.TIPOLANCE){
                case "Sala/Telefone":
                  icon = '<i class="fas fa-hand-paper"></i>';
                  lanceclass = 'is-lance-sala';
                  break;
                case "Automático":
                  icon = '<i class="fas fa-laptop"></i>'
                  lanceclass = 'is-lance-automatico';
                  break;  
                default:
                  icon = '<i class="fas fa-gavel"></i>'
                  lanceclass = 'is-lance-normal';
              }
            }
          }

          
          // se for lance vencedor, monta a caixa de lance vencedor e preenche os locais corretos
          if(maiorlance.VENCEDOR===true){
            defineIconLance(maiorlance);

            obj.lancevencedor.IDLANCE = maiorlance.IDLANCE;
            obj.lancevencedor.TIPOLANCE = maiorlance.TIPOLANCE;
            obj.lancevencedor.VALOR = maiorlance.VALOR;
            obj.lancevencedor.IDCLIENTE = parseInt(maiorlance.IDCLIENTE);
            //atualiza os valores em todos locais necessários
            obj.atualizaValores(icon, lanceclass, maiorlance.QTDLANCE);
          }         
          //loop do menor lance ao maior
          for(var i=mensagem_lance.LANCES.length - 1; i>=1; i--){
            // if(!obj.registralances.includes(mensagem_lance.LANCES[i].IDLANCE)){
            //   var lanceatual = mensagem_lance.LANCES[i];
            //   b++;
            //   defineIconLance(lanceatual);
            //   obj.registralances.push(lanceatual.IDLANCE);
            //   obj.geraLanceRender(lanceatual, icon, lanceclass, b, novolote);
            // }
            var checaindex = obj.registralances.indexOf(mensagem_lance.LANCES[i].IDLANCE);
            if(checaindex===-1){
              var lanceatual = mensagem_lance.LANCES[i];
              b++;
              defineIconLance(lanceatual);
              obj.registralances.push(lanceatual.IDLANCE);
              obj.geraLanceRender(lanceatual, icon, lanceclass, b, novolote);
            } else {
              // verificação se algum lance foi removido
              var lastreg = obj.registralances.length - 1;
              if(i===1 && checaindex != lastreg){
                var currid = obj.registralances[lastreg];
                $('#'+currid).remove();
                obj.registralances.pop();
              }
            }
          }
          // ativa valores
          obj.ativaDesativaValores(true);
          }
        } else { // peca sem lance
          if(obj.semlance===0){
            // se nao tiver lances, limpa tudo e usa o valor inicial
            obj.atualizaSemLance(objinfoleilao.INFOLEILAO.VALOR_CONTRATADO);
            obj.ativaDesativaValores(true);
          }
        }//fim verificao se tem lances       

        // define o que acontece em cada status
        if(obj.statusatual!=objinfoleilao.INFOLEILAO.STATUS && objinfoleilao.INFOLEILAO.STATUS!="N") {
          obj.statusatual = objinfoleilao.INFOLEILAO.STATUS;
          obj.imprimeToast(objinfoleilao.INFOLEILAO.ID_COMPRADOR, b);
        }


      }// fim np
      //const t1 = performance.now();
      //console.log(`Call to doSomething took ${t1 - t0} milliseconds.`);
      objinfoleilao = null;
      array1 = null;
      mensagem_salao = null;
      // se for primeiro load, espera 3segs para começar o loop
      if(pfirst) {
        setTimeout(function(){
          obj.LePregao();
        },2000)
      } else {
        var espera = 2000;
        if(obj.logado===1) { espera = 1000; }
        setTimeout(function(){
          obj.LePregao();
        },espera);
      }
    });
  }

}
